import { HelpOutline } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { Fragment } from "react";

InfoPopover.propTypes = {
  item: PropTypes.object.isRequired,
};

export default function InfoPopover(props) {
  const { item } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (!item.description) return <Fragment></Fragment>;
  else
    return (
      <Fragment>
        <Tooltip title="für weitere Informationen hier klicken">
          <IconButton onClick={handleClick} sx={{ mt: "-20px" }}>
            <HelpOutline sx={{ width: "28px" }} />
          </IconButton>
        </Tooltip>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box sx={{ margin: "16px", maxWidth: "450px" }}>
            <Typography variant="regular_text_14px_normal">
              {item.description}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "right", pt: "10px" }}>
              <Button color="primary" size="small" onClick={handleClose}>
                schliessen
              </Button>
            </Box>
          </Box>
        </Popover>
      </Fragment>
    );
}
